import Preference from './preference';
import Notification from './notification';

const Settings = ({ preference, updateUserPreference }) => {
  return (
    <div className='space-y-4'>
      <Notification />
      <Preference
        preference={preference}
        updateUserPreference={updateUserPreference}
      />
    </div>
  );
};

export default Settings;
